// auto-generated by Typewriter template _models.tst from PortCall.Core.EndPoints\Api\Role\ApiRole.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { UserRole, UserRoleData, UserRoleOptions } from 'data/models/UserRole';

// RoleData is the class that Role serializes to/from
export interface RoleData {
    Id : number;
	
    Users : UserRoleData[] | null;
	
    Description : string | null;
    Name : string | null;
    Order : number;
}

// RoleOptions is the class which may be passed to the Role constructor to define optional initial data values
export interface RoleOptions {
    Id : number;
	
    Users? : UserRoleOptions[] | null;
	
    Description? : string | null;
    Name? : string | null;
    Order? : number;
}

export class Role {
    public Id : DataSignal<number>;
	
    public Users : SDataArray<UserRole>;
	
    public Description : DataSignal<string | null>;
    public Name : DataSignal<string | null>;
    public Order : DataSignal<number>;

    constructor();
    constructor(data : RoleOptions);
    constructor(data: RoleOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.Users = SArray<UserRole>([]);
	    
        this.Description = jsonableObservable(S.value<string | null>(data && data.Description !== undefined ? data.Description : null));
        this.Name = jsonableObservable(S.value<string | null>(data && data.Name !== undefined ? data.Name : null));
        this.Order = jsonableObservable(S.value<number>(data && data.Order !== undefined ? data.Order : 0));
    }

    static key(obj : Role) {
        return obj.Id();
    }
    
    static dataKey(obj : RoleOptions) {
        return obj.Id;
    }

    static update(obj : Role, data : RoleOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
	        
            if (data.Description !== undefined) obj.Description(data.Description);
            if (data.Name !== undefined) obj.Name(data.Name);
            if (data.Order !== undefined) obj.Order(data.Order);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/Role.ts